import React from 'react';
import { useSyncStatus } from './sdk';
import { isOfflineSyncConfigured } from './session';

const COLORS: Record<string, string> = {
  IDLE: '#16a34a',
  SYNCING: '#6b7280',
  OFFLINE: '#b45309',
  ERROR: '#dc2626',
  UNINITIALIZED: '#9ca3af',
};

const LABELS: Record<string, string> = {
  IDLE: 'Synchronisé',
  SYNCING: 'Synchronisation…',
  OFFLINE: 'Hors-ligne',
  ERROR: 'Erreur de synchro',
  UNINITIALIZED: 'En attente',
};

/** Compact header chip reflecting the live OfflineSync state. Hidden when the feature isn't configured. */
export function SyncStatusIndicator(): React.ReactElement | null {
  const status = useSyncStatus();
  if (!isOfflineSyncConfigured()) return null;

  const color = COLORS[status.state] ?? COLORS.UNINITIALIZED;
  const label = LABELS[status.state] ?? '';
  const time = status.lastSyncAt ? new Date(status.lastSyncAt).toLocaleTimeString() : null;
  const title = time ? `${label} · ${time}` : label;

  return (
    <button type="button" className="icon-btn" title={title} aria-label={`Synchronisation : ${title}`}>
      <span
        style={{
          display: 'inline-block',
          width: 10,
          height: 10,
          borderRadius: 9999,
          background: color,
          boxShadow: status.state === 'SYNCING' ? `0 0 0 3px ${color}33` : undefined,
        }}
      />
    </button>
  );
}

export default SyncStatusIndicator;
